module.exports = __webpack_public_path__ + "img/revenue-streams-icon.a7712400.svg";